import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BackendErrorTranslatorService } from '../localization/backend-error-translator.service';
import { AbstractApiV2Service } from '../../api/services/abstract-api-v2.service';

@Injectable({
    providedIn: 'root',
})
export class SidenavService extends AbstractApiV2Service<any> {
    public logo = '';
    public sidenavButtons: any[] = [];
    protected resourceName: string = 'sidenav-counts';

    constructor(http: HttpClient, backendErrorTranslator: BackendErrorTranslatorService) {
        super(http, backendErrorTranslator);
    }

    public getAllNotifications(selectedCompany: string | null) {
        let filterByCompany = {};
        if (selectedCompany) {
            filterByCompany = { company: selectedCompany };
        }
        return this.getAll(filterByCompany);
    }
}
